"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryToLookFilterMapper = void 0;
const lookFilter_1 = require("../dtos/lookFilter");
const queryToLookFilterMapper = (lookQueryDto) => {
    const query = lookQueryDto.query;
    if (query) {
        const filterConfig = query.filterConfig;
        return Object.keys(filterConfig).map((filterConfigKey) => {
            return new lookFilter_1.LookFilter(filterConfig[filterConfigKey][0].id, lookQueryDto.id.toString(), filterConfigKey, filterConfig[filterConfigKey][0].type, filterConfig[filterConfigKey][0].values[0].constant, query.model, query.view, filterConfigKey);
        });
    }
    return [];
};
exports.queryToLookFilterMapper = queryToLookFilterMapper;
